import { Injectable } from '@angular/core';
import { SupabaseCore } from './supabase.core';

@Injectable({
  providedIn: 'root',
})
export class SupabaseFunctions {
  constructor(private supabaseCore: SupabaseCore) {}

  invoke(functionName: string, options: any) {
    return this.supabaseCore.client.functions.invoke(functionName, options);
  }
}
